var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.9974 0.666016C3.95406 0.666016 0.664062 3.95602 0.664062 7.99935C0.664062 12.0427 3.95406 15.3327 7.9974 15.3327C12.0407 15.3327 15.3307 12.0427 15.3307 7.99935C15.3307 3.95602 12.0407 0.666016 7.9974 0.666016ZM6.69673 11.6413L3.7214 8.66602L4.66406 7.72335L6.6314 9.69068L11.2681 4.39202L12.2714 5.27002L6.69673 11.6413Z",
    fill: "#680DDB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.855883e9849a39a94c591481fe1daf26.svg";
export { ForwardRef as ReactComponent };